export default {
  title: 'Datenquelle erstellen',
};
